<template>
    <div>
        <div id="selected-icon" :class="{disabled}" @click="openModal">
            <i :class="[$_prefixClass, $_icon]" />
        </div>

        <oc-modal
            :closeButton="false"
            :closeOnBackdrop="true"
            :show="showModal"
            @close="showModal = false"
            @confirm="emitState"
        >
            <div class="oc-icons-list">
                <ul>
                    <li v-for="(iconClass, index) of icons" :key="index" @click="select(iconClass)" v-class="{selected: isSelected(iconClass)}">
                        <a href="javascript:;" class="oc-native-noselect">
                            <i v-class="[$_prefixClass, iconClass]" />
                        </a>
                    </li>
                </ul>
            </div>
        </oc-modal>
    </div>
</template>

<script>
    export default {
        name: "oc-icon-picker",
        props: {
            value: {
                default: 'fa-globe'
            },
            type: {
                type: String,
                default: 'fa',
                validator: function (value) {
                    return ['fa', 'oc', 'custom'].indexOf(value) !== -1
                }
            },
            cssFileName: {
                type: String
            },
            selectorMatch: {
                type: [Function, Object]
            },
            prefixClass: {
                type: String
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        watch: {
            value: {
                immediate: true,
                handler(newValue) {
                    this.icon = newValue
                    this.selected = newValue
                }
            }
        },
        data() {
            return {
                icon: null,
                selected: null,
                showModal: false
            }
        },
        methods: {
            openModal() {
                if (this.disabled) {
                    return
                }
                this.selected = this.icon
                this.showModal = true
            },
            isSelected(iconClass) {
                return this.selected === iconClass
            },
            select(iconClass) {
                this.selected = iconClass
            },
            emitState() {
                this.icon = this.selected
                this.$emit('input', this.icon)
                this.showModal = false
            }
        },
        computed: {
            $_icon() {
                let icon = this.icon

                // we make sure have the right prefix

                if( this.type === 'fa' ) {
                    icon =  'fa-' + icon.replace(/^(fa\-)/, '')
                }
                else if( this.type === 'oc' ) {
                    icon = 'oc-' + icon.replace(/^(oc\-)/, '')
                }

                return icon
            },
            $_prefixClass() {
                if( this.prefixClass ) {
                    return this.prefixClass
                }

                if( this.type === 'fa' ) {
                    return 'fa'
                } else if( this.type === 'oc' ) {
                    return null
                }

                return null
            },
            $_cssFileName() {
                if( this.cssFileName ) {
                    return this.cssFileName
                }

                if( this.type === 'fa' ) {
                    return 'font-awesome.'
                } else if( this.type === 'oc' ) {
                    return 'oc-icons.'
                }

                return null
            },
            $_selectorMatch() {
                if( this.selectorMatch ) {
                    return this.selectorMatch
                }

                if( this.type === 'fa' ) {
                    return /\.(fa-[a-z-]+):+/mi;
                } else if( this.type === 'oc' ) {
                    return /^i[.](oc-.*)::/;
                }

                return
            },
            icons() {
                // load icons from oc-icons.css
                var icons = [];

                for (var cssIndex in document.styleSheets)
                {
                    var css = document.styleSheets[cssIndex];

                    if (
                        css.href !== undefined &&
                        css.href !== null &&
                        css.href.indexOf(this.$_cssFileName) !== -1
                    ) {
                        var classes = css.rules || css.cssRules;

                        for (var c = 0; c < classes.length; c++)
                        {
                            var cssClass = classes[c];
                            if (cssClass.selectorText !== undefined)
                            {
                                var match = null

                                if (this.$_selectorMatch instanceof RegExp) {
                                    match = this.$_selectorMatch.exec(cssClass.selectorText)
                                } else {
                                    match = this.$_selectorMatch(cssClass.selectorText)
                                }

                                if (match !== null)
                                {
                                    var found = match[1]

                                    if( ! inArray(found, icons) ) {
                                        icons.push(found)
                                    }
                                }
                            }
                        }
                    }
                }

                return icons;
            }
        }
    }
</script>

<style scoped>
    #selected-icon
    {
        cursor: pointer;
        font-size:30px;
        color:#f0ad4e;
        padding:5px;
        min-width:40px;
        height:40px;
        text-align:center;
        border: dotted 1px gray;
        display: inline-block;
    }

    #selected-icon.disabled {
        cursor: default;
    }

    #selected-icon i
    {
        display:block;
    }

    .oc-icons-list
    {
        clear:both;
        padding:5px;
        border:solid 1px #a8abb4;
        border-radius:4px;
    }

    .oc-icons-list ul
    {
        height:224px;
        overflow-y:auto;
        margin: 0;
        padding: 0;
    }

    .oc-icons-list ul li
    {
        float:left;
        border:dotted 1px gray;
        margin:2px;
        padding:2px;
        width:40px;
        height:40px;
        text-align:center;
        cursor: pointer;

        list-style-image: none;
        list-style-position: outside;
        list-style-type: none;

        box-sizing: border-box;
    }

    .oc-icons-list ul li a
    {
        text-decoration: none;
        outline: none;
        transition: all 0.2s;
    }

    .oc-icons-list ul li i
    {
        line-height:35px;
        font-size:32px;
        color:gray;
    }

    .oc-icons-list ul li.selected,
    .oc-icons-list ul li:hover
    {
        border:solid 1px #f0ad4e;

    }

    .oc-icons-list ul li.selected i,
    .oc-icons-list ul li:hover i
    {
        color:#f0ad4e;
    }

    .oc-icons-list ul li.selected a,
    .oc-icons-list ul li.selected a:hover
    {
        cursor: default;
    }

    .oc-icons-list ul li a:hover
    {
        text-decoration: none;
    }
</style>
